module.exports = __webpack_public_path__ + "media/images/xpass/icons/calendar-b3d6e64c582711b7961aee4c427535dd.svg";